/**
 * Format seconds into hh:mm:ss with optional hh part
 * Returns --:-- if content type is not a number
 * @param content duration in seconds as number or string
 * @returns duration format string
 */
export const watchTimeFormat = (content?: number | string | null) => {
    const n = Number(content);
    if (content === undefined || content === null || isNaN(n) || content === '') {
        return '--:--';
    }

    if (n <= 0) {
        return '00:00';
    }

    let seconds = Math.floor(n);
    seconds = seconds < 0 ? 0 : seconds;
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    seconds -= minutes * 60;
    minutes -= hours * 60;

    const secondsStr = seconds < 10 ? '0' + seconds : seconds;
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    const hoursStr = hours < 10 ? '0' + hours : hours;
    return (hoursStr === '00' ? '' : hoursStr + ':') + `${minutesStr}:${secondsStr}`;
};
